/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgWifiOff(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M.47.47a.75.75 0 011.06 0l5.11 5.108a.75.75 0 01.022.023l3.96 3.961c.056.042.105.09.147.146L23.53 22.47a.75.75 0 11-1.06 1.06l-6.72-6.72a.749.749 0 01-.704-.089 5.25 5.25 0 00-6.082 0 .75.75 0 01-.868-1.222 6.75 6.75 0 015.224-1.119l-3.408-3.407a10.19 10.19 0 00-4.43 2.152.75.75 0 11-.963-1.15 11.69 11.69 0 014.16-2.235L5.944 7.004a15.16 15.16 0 00-4.027 2.558.75.75 0 11-.994-1.124 16.66 16.66 0 013.888-2.567L.47 1.531A.75.75 0 01.47.47zm16.34 6.058a15.25 15.25 0 00-6.04-.73.75.75 0 01-.12-1.496 16.75 16.75 0 0112.426 4.136.75.75 0 11-.992 1.124 15.25 15.25 0 00-5.274-3.034zm-.764 4.203a.75.75 0 011.003-.345c.875.427 1.694.962 2.436 1.592a.75.75 0 11-.97 1.144 10.19 10.19 0 00-2.124-1.388.75.75 0 01-.345-1.003zM11.25 20a.75.75 0 01.75-.75h.01a.75.75 0 010 1.5H12a.75.75 0 01-.75-.75z'
        />
      </g>
      <defs>
        <clipPath id='wifi-off_svg__clip0_126_10326'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgWifiOff;
